/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebfieldwebsite3Inputs */

const en_placewebfieldwebsite3 = /** @type {(inputs: Placewebfieldwebsite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

const de_placewebfieldwebsite3 = /** @type {(inputs: Placewebfieldwebsite3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

/**
* | output |
* | --- |
* | "Website" |
*
* @param {Placewebfieldwebsite3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebfieldwebsite3 = /** @type {((inputs?: Placewebfieldwebsite3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebfieldwebsite3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebfieldwebsite3(inputs)
	return de_placewebfieldwebsite3(inputs)
});
export { placewebfieldwebsite3 as "placeWebFieldWebsite" }